export const PRINT = 'print';

export const MOBILE = '(min-width: 481px) and (max-width: 480px)';
export const TABLET = '(min-width: 481px) and (max-width: 768px)';
export const LAPTOP = '(min-width: 769px) and (max-width: 1024px)';
export const DESKTOP = '(min-width: 1025px) and (max-width: 1200px)';
export const TV = '(min-width: 1201px)';

/** @type {Range} */
const xs = [0, 575];
/** @type {Range} */
const sm = [576, 767];
/** @type {Range} */
const md = [768, 991];
/** @type {Range} */
const lg = [992, 1199];
/** @type {Range} */
const xl = [1200, 1399];
/** @type {Range} */
const xxl = [1400, 99_999_999_999];

/**
 * @typedef {[number, number]} Range
 */

/**
 *
 * @param {Range} range
 * @returns
 */
const down = range => `(max-width: ${range[1]}px)`;

/**
 *
 * @param {Range} range
 * @returns
 */
const up = range => `(min-width: ${range[0]}px)`;

/**
 *
 * @param {Range} range
 * @returns
 */
const exact = range => `(min-width: ${range[0]}px) and (max-width: ${range[1]}px)`;

export const XS_AND_UP = up(xs);
export const SM_AND_UP = up(sm);
export const MD_AND_UP = up(md);
export const LG_AND_UP = up(lg);
export const XL_AND_UP = up(xl);
export const XXL_AND_UP = up(xxl);

export const XS_AND_DOWN = down(xs);
export const SM_AND_DOWN = down(sm);
export const MD_AND_DOWN = down(md);
export const LG_AND_DOWN = down(lg);
export const XL_AND_DOWN = down(xl);
export const XXL_AND_DOWN = down(xxl);

export const XS = exact(xs);
export const SM = exact(sm);
export const MD = exact(md);
export const LG = exact(lg);
export const XL = exact(xl);
export const XXL = exact(xxl);

class Breakpoints {
	/**
		*
		* @param {string} mediaQuery
		*/
	create(mediaQuery) {
		// if (Array.isArray(mediaQuery)) {
		// 	const mappedMQ = mediaQuery.map(m => m);
		// 	// const mappedMQ = mediaQuery.map(m => `(${m})`);
		// 	const concatMQ = mappedMQ.join(', ');
		// 	console.log('concatMQ', concatMQ);
		// 	return window.matchMedia(concatMQ);
		// }
		return window.matchMedia(mediaQuery);
	}

	/**
		*
		* @param {string} mediaQuery
		* @returns {boolean} Wether or not the media query match
		*/
	is(mediaQuery) {
		const mq = window.matchMedia(mediaQuery);
		return mq.matches;
	}

	isPrint() {
		return this.is(PRINT);
	}
}

const breakpoints = new Breakpoints();

export {
	breakpoints as Breakpoints,
};
